export const Rumantsch = {
  weekdays: {
    shorthand: ['Du', 'Gli', 'Ma', 'Me', 'Gie', 'Ve', 'So'],
    longhand: [
      'Dumengia',
      'Glindesdis',
      'Mardi',
      'Mesemna',
      'Gievgia',
      'Venderdi',
      'Sonda',
    ],
  },
  months: {
    shorthand: [
      'Schan',
      'Favr',
      'Mars',
      'Avr',
      'Matg',
      'Zercl',
      'Fan',
      'Avust',
      'Sett',
      'Oct',
      'Nov',
      'Dec',
    ],
    longhand: [
      'Schaner',
      'Favrer',
      'Mars',
      'Avrigl',
      'Matg',
      'Zercladur',
      'Fanadur',
      'Avust',
      'Settember',
      'October',
      'November',
      'December',
    ],
  },
  firstDayOfWeek: 1,
  weekAbbreviation: 'Emna',
  rangeSeparator: ' fin ',
  scrollTitle: 'Per modifitgar scrollar',
  toggleTitle: 'Per midar cliccar',
  time_24hr: true,
};

export default Rumantsch;
